// CSS Modules - component class name prefix: ShopProductList__

<template>
  <div :class="$style.container">
    <div :class="[$style.bestSellers, 'columns is-multiline']" v-if="isBestSellers">
      <div
        class="column is-half-tablet is-one-third-desktop productContainer"
        v-for="(product, index) in bestSellers"
        :key="index"
      >
        <div class="image">
          <a href="#">
            <img src="https://shop.wika.de/upload/WIKA_Thumbnails/Product-MicrositeEntry-Thumb/PIC_PR_A_10_de_de_2942.jpg.png" alt="Typ A-10" />
          </a>
        </div>
        <div class="content">
          <a href="#">
            <span class="markup5">Drucksensor</span>
            <span>Für allgemeine industrielle Anwendungen</span>
            <p class="typ">Typ A-10</p>
          </a>
        </div>
        <div class="productProperties">
          <div class="productPropertiesLeft">
            <span class="shop-price">
              <strong>ab 107,64 €</strong>
              zzgl. MwSt. &amp;
              <a href="#">Versand</a>
            </span>
          </div>
          <div class="productPropertiesRight">
            <a href="#">
              <span>Zum Produkt</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div :class="[$style.newProducts, 'columns is-multiline']" v-else>
      <div
        class="column is-half-tablet is-one-third-desktop productContainer"
        v-for="(product, index) in newProducts"
        :key="index"
      >
        <div class="image">
          <a href="#">
            <img src="https://shop.wika.de/upload/WIKA_Thumbnails/Product-MicrositeEntry-Thumb/PIC_PR_A_10_de_de_2942.jpg.png" alt="Typ A-10" />
          </a>
        </div>
        <div class="content">
          <a href="#">
            <span class="markup5">Drucksensor</span>
            <span>Für allgemeine industrielle Anwendungen</span>
            <p class="typ">Typ A-10</p>
          </a>
        </div>
        <div class="productProperties">
          <div class="productPropertiesLeft">
            <span class="shop-price">
              <strong>ab 107,64 €</strong>
              zzgl. MwSt. &amp;
              <a href="#">Versand</a>
            </span>
          </div>
          <div class="productPropertiesRight">
            <a href="#">
              <span>Zum Produkt</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopProductList",
  props: {
    isBestSellers: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      newProducts: 3,
      bestSellers: 6
    };
  }
};
</script>

<style module lang="scss">
@import "./ShopProductList.scss";
</style>
